import { useNavigate } from "react-router-dom";
import { Calendar, Ticket, Clock, Users, Building, Bot, Mail, Gift, FileText, Trophy, Train, Building2 } from "lucide-react";

const LINKS = [
  ["/admin/planning", "Planning", Calendar],
  ["/admin/ticket", "Ticket", Ticket],
  ["/admin/slots", "Créneaux", Clock],
  ["/admin/customers", "Clients", Users],
  ["/admin/customers?filter=pro", "Clients Pro", Building],
  ["/admin/conciergerie", "Conciergerie", Building2],
  ["/admin/delivery-slips", "Bons Livraison", FileText],
  ["/admin/trenitalia", "Trenitalia", Train],
  ["/admin/sakura", "IA Sakura", Bot],
  ["/admin/chat-history", "Historique IA", Bot],
  ["/admin/email", "Email masse", Mail],
  ["/admin/referrals", "Parrainages", Gift],
  ["/admin/snake-leaderboard", "Podium Snake", Trophy],
];

export const AdminMobileNav = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-wrap gap-2 pb-2" data-testid="admin-mobile-nav">
      {LINKS.map(([path, label, Icon]) => (
        <button key={path} onClick={() => navigate(path)} data-testid={`mobile-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
          className="inline-flex items-center gap-1 px-3 py-2 rounded-md border bg-white text-sm font-medium hover:bg-slate-100">
          <Icon className="w-4 h-4" />{label}
        </button>
      ))}
    </div>
  );
};
